import { Component, OnInit } from '@angular/core';
// import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner/ngx';
// import { BarcodeScannerOriginal, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { BarcodeScanner, BarcodeScannerOptions } from "@ionic-native/barcode-scanner/ngx";
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner/ngx';

@Component({
  selector: 'app-code-scanner',
  templateUrl: './code-scanner.page.html',
  styleUrls: ['./code-scanner.page.scss'],
})
export class CodeScannerPage implements OnInit {
  // scannedData: any;
  encodedData: '';
  encodeData: any;
  inputData: any;

  showScanner = false;
  scannedData: string = '';
  constructor(
    private barcodeScanner: BarcodeScanner,
    private qrScanner: QRScanner,
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    // this.scanBarcode()
  }



  scanBarcode() {
    const options: BarcodeScannerOptions = {

      preferFrontCamera: false,
      showFlipCameraButton: true,
      showTorchButton: true,
      torchOn: false,
      prompt: 'Place a barcode inside the scan area',
      resultDisplayDuration: 500,
      formats: 'EAN_13,EAN_8,QR_CODE,PDF_417 ',
      orientation: 'portrait',
    
    };
    this.barcodeScanner.scan(options).then(barcodeData => {
      console.log("barcode scanner =========>", barcodeData);
      // this.scannedData = barcodeData.text;
      console.log("scannedddddd =====", this.scannedData)
    }).catch(err => {
      console.log("Error1", err)
    });
  }

  createBarcode() {
    this.barcodeScanner.encode(this.barcodeScanner.Encode.TEXT_TYPE, this.inputData).then((encodedData) => {
      console.log("EncodedDate =========>", encodedData);
      this.encodedData = encodedData.file;
      console.log("endocedsdnsdmds", this.encodedData)
    });

  }


  startScanner() {
    this.qrScanner.prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          this.showScanner = true;
          this.qrScanner.show();
          this.qrScanner.scan().subscribe((text: string) => {
            this.scannedData = text;
            this.stopScanner();
          });
        } else if (status.denied) {
          console.error('Camera permission denied');
        } else {
          console.error('Camera access not available');
        }
      })
      .catch((error: any) => console.error('Error preparing QR scanner:', error));
  }
  stopScanner() {
    this.showScanner = false;
    this.qrScanner.hide();
    this.qrScanner.destroy();
  }






}
